import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { IconSettings, Button, Card, Modal } from '@salesforce/design-system-react';
import Sidebar from '../../Components/Sidebars/App/Sidebar';
import CircleButton from '../../Components/Personas/CircleButton';
import CustomModal from '../../Components/Personas/CustomModal';
import CustomToastContainer from '../../Components/App/CustomToastContainer';
import PersonaInstructions from '../../Components/Sidebars/Instructions/PersonaInstructions';
import Banner from '../../Components/App/Banner';
import VidyardEmbed from '@vidyard/embed-code';
import { socket } from '../../socket';
import PersonaMethod from '../../Components/Personas/PersonaMethod';
import PageBlockHeader from '../../Components/PageBlockHeader';
import PersonaModalHeader from '../../Components/Personas/PersonaModalHeader';
import AddIdea from '../../Components/AddIdea';

import {
  setStepId, 
  addToast,
  addIdeaDBOnly,
  addIdea,
  deleteIdeaDBOnly,
  deleteIdea,
  selectIdeaDBOnly,
  selectIdea,
  updateIdeaDBOnly,
  updateIdea,
  addPersonaDBOnly,
  addPersona,
  deletePersona,
  deletePersonaDBOnly,
  editPersona
} from '../../actions';

function useToggle(initialValue = false) {
  const [value, setValue] = React.useState(initialValue);

  const toggle = React.useCallback(() => {
    setValue(v => !v);
  }, []);

  return [value, toggle];
}

function Personas (props) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editId, setEditId] = useState(null);
  const [createPersona, setCreatePersona] = useState(true);

  const [editIdeaId, setEditIdeaId] = useState(null);
  const [content, setContent] = useState('');
  const [method, setMethod] = useState('');
  const [isIdeaOpen, setIsIdeaOpen] = useToggle();

  const [responsibilityIdea, setResponsibilityIdea] = useState('');
  const [painPointIdea, setPainPointIdea] = useState('');
  const [futureGoalIdea, setFutureGoalIdea] = useState('');

  useEffect(() => { 
    VidyardEmbed.api.renderDOMPlayers();
     //socket.emit('onLoadServer', props.journeyId);
     socket.emit('onAddActiveCollaboratorServer',{ "journeyId": props.journeyId, "email": props.username } );
  }, []);

  const goToBusinessChallenge = () => {
    props.history.push('/Personas');
    
    window.location.href = '/BusinessChallenge';
  };

  const goToMilestones = () => {
    if (Object.keys(props.personas).length <= 1) {
      props.addToast({
        labels: {
          heading: 'We recommended to have at least 2 personas before you proceed',
        },
        variant: 'warning',
      });
    }

    props.setStepId(3);

    props.history.push('/Personas');

    window.location.href = '/Milestones';
  };

  const toggleModalOpen = (persona) => {
    if (persona >= 0) {
      setEditId(persona);
    } else {
      setEditId('');
    }
    setIsModalOpen(!isModalOpen);
  };

  const closeAddIdea = () =>{
    setContent('');
    setIsIdeaOpen();
    setEditIdeaId(null);
  }

  const addIdea = () => {
    if (content !== undefined && content !== '' && editIdeaId !== null && content.length < 256) {
      props.updateIdeaDBOnly(editId, editIdeaId, method.charAt(0).toLowerCase() + method.substring(1), content);

      closeAddIdea();
    } else if (content !== undefined && content !== '' && content.length < 256) {
      props.addIdeaDBOnly(props.journeyId, editId, method.charAt(0).toLowerCase() + method.substring(1), content);

      closeAddIdea();
    } else if (content.length >= 256) {
      props.addToast({ labels: { heading: 'Idea needs to be 255 or less characters.' }, variant: 'error' });
    } else {
      props.addToast({
        labels: {
          heading: 'Please make sure your idea has content.',
        },
        variant: 'error',
      });
    }
  };


  const onDropdownSelected = (id, value, content, chosen, method) => {
    if (value === 'Delete') {
      props.deleteIdeaDBOnly(editId, method.toLowerCase(), parseInt(id));
    }

    if (value === 'Select') {
      props.selectIdeaDBOnly(props.journeyId, editId, method.toLowerCase(), parseInt(id));
    }

    if (value === 'Save') {
      props.updateIdeaDBOnly(editId, parseInt(id), method.toLowerCase(), content);
    }
  }

  const deletePersonaAction = async (personaId) => {
    await props.deletePersonaDBOnly(personaId);
    setEditId(null);
    setCreatePersona(true);
  };

  const editPersonaNow = (personaId) => {
    setEditId(personaId);
    setCreatePersona(false);
  }

  const openEditIdea = (id, content, method) => {
    if(id) {
      setEditIdeaId(id);
      setContent(content);
    }

    setMethod(method);
    setIsIdeaOpen();
  }

  return (
    <IconSettings iconPath="/icons">
      <CustomToastContainer />
      <div className="outer-container">
          <Sidebar 
            stage="Personas"
            instructions={<PersonaInstructions />}
          />
          <Banner
            backgroundColor='#FDF8CD'
            previous={goToBusinessChallenge}
            next={goToMilestones}
            stage="Personas"
            backgroundImage='/Images/Banners/HeroBanners-02.png'
          />
          <div>
            {/*<SocketListeners />*/}
            <div style={{ marginLeft: 'max(210px, 15%)'}}>
              <div className="slds-p-horizontal_x-large slds-p-vertical_medium">
                <Card
                  header={
                    <div className="slds-grid" style={{ width: '100%'}}>
                      <div className="slds-size_11-of-12">
                        <PageBlockHeader
                          hasBorder={false}
                          title={`Define `}
                          addtl={`Personas`}
                          subtitle={`Step 1: Define the Hero. Step 2: Add supporting personas.`}
                        />
                      </div>
                      <div className="slds-size_1-of-12">
                        <Button 
                          label="Next Stage" 
                          variant="brand" 
                          onClick={goToMilestones}
                        />
                      </div>
                    </div>
                  }
                  className="slds-m-top_x-small"
                >
                <div
                  style={{
                    margin: 'auto',
                    display: 'flex',
                    flexWrap: 'wrap',
                  }}
                  className="slds-grid"
                >
                  <ul className="slds-size_1-of-6">
                    <li 
                      className="slds-align_absolute-center slds-p-around_medium" 
                      style={editId === null ? 
                        {backgroundColor: '#FFF', borderRight: ''}:
                        {backgroundColor: '#EAF5FE', borderRight: '1px solid rgba(1, 118, 211, .3)'}
                      }
                    >
                      <CircleButton
                        onBtnClick={() => { 
                          setCreatePersona(true)
                          setEditId(null);
                        }}
                        textBelow="Create Persona"
                        imgPath="/icons/utility/add.svg"
                        color="rgba(1, 118, 211, .9)"
                        imgSize="40"
                        outerClass="plus-icon"
                      />
                    </li>
                    
                    {Object.keys(props.personas).map((persona) => {
                      const personaDetails = props.personas[persona];
                      const imgPath = personaDetails.picUrl;

                      return (
                        <li className="slds-align_absolute-center slds-p-around_medium" 
                          style={personaDetails.id === editId ? 
                            {backgroundColor: '#FFF', borderRight: ''}:
                            {backgroundColor: '#EAF5FE', borderRight: '1px solid rgba(1, 118, 211, .3)'}
                          }
                        >
                          <CircleButton
                            onBtnClick={editPersonaNow}
                            key={personaDetails.id}
                            inactive={true}
                            isEditable={true}
                            isHero={personaDetails.hero}
                            textBelow={personaDetails.name}
                            textBelow2={personaDetails.role}
                            personaId={personaDetails.id}
                            onEditBtnClick={toggleModalOpen}
                            onDeleteBtnClick={deletePersonaAction}
                            imgPath={imgPath}
                            imgSize="150"
                            outerClass=""
                          />
                        </li>
                      );
                    })}                    
                  </ul>
                  <div className="slds-size_5-of-6">
                    { editId !== null ? (
                      <div className="slds-m-horizontal_large slds-p-around_medium" style={{ border: '1px solid #eee', borderRadius: '5px'}}>
                        <PersonaModalHeader />
                        <CustomModal
                          editing={true}
                          personaId={editId}
                        />
                        <div className="slds-grid">
                          <div className="slds-col slds-size_1-of-3">
                            <PersonaMethod
                              personaId={editId}
                              methodName="Responsibility"
                              ideas={props.ideas['responsibility']}
                              idea={responsibilityIdea}
                              onChange={setResponsibilityIdea}
                              onDropdownSelected={onDropdownSelected}
                              onButtonClick={() => openEditIdea(null, null, "Responsibility")}
                              openEditIdea={openEditIdea}
                          />
                          </div>
                          <div className="slds-col slds-size_1-of-3 slds-p-horizontal_x-small">
                            <PersonaMethod
                              personaId={editId}
                              methodName="Pain"
                              onAdd={addIdea}
                              ideas={props.ideas['pain']}
                              idea={painPointIdea}
                              onChange={setPainPointIdea}
                              onDropdownSelected={onDropdownSelected} 
                              onButtonClick={() => openEditIdea(null, null, "Pain")}
                              openEditIdea={openEditIdea}
                            />
                          </div>
                          <div className="slds-col slds-size_1-of-3">
                            <PersonaMethod
                              personaId={editId}
                              methodName="Goal"
                              ideas={props.ideas['goal']}
                              idea={futureGoalIdea}
                              onChange={setFutureGoalIdea}
                              onDropdownSelected={onDropdownSelected}
                              onButtonClick={() => openEditIdea(null, null, "Goal")}
                              openEditIdea={openEditIdea}
                            />
                          </div>
                        </div>
                      </div>
                    ) : null }
                    { createPersona ? (
                      <div className="slds-m-horizontal_large slds-p-around_medium" style={{ border: '1px solid #eee', borderRadius: '5px'}}>
                        <PersonaModalHeader />
                        <CustomModal
                          editing={false}
                          personaId={null}
                        />
                      </div>
                    ) : (null)}
                  </div>
                </div>
              </Card>
            </div>
          </div>
        </div>

        <Modal
          isOpen={isIdeaOpen}
          onRequestClose={closeAddIdea}
        >
          <AddIdea
            milestone={method}
            value={content}
            onChange={(e) => setContent(e.target.value)}
            onAdd={addIdea}
            onCancelButtonClick={closeAddIdea}
          />
        </Modal>
      </div>
    </IconSettings>
  );
}

const mapStateToProps = (state) => ({
  journeyId: state.app.journeyId,
  username: state.app.username,
  businessChallenge: state.businessChallenge,
  personas: state.personas,
  ideas: state.ideas,
});

const mapDispatchToProps = (dispatch) => ({
  setStepId: (stepId) => dispatch(setStepId(stepId)),
  addToast: (toast) => dispatch(addToast(toast)),

  // -- ADD IDEA START --
  addIdeaDBOnly: (journeyId, personaId, stageName, ideaContent) =>
    dispatch(addIdeaDBOnly(journeyId, personaId, stageName, ideaContent)),
  addIdea : (ideaId, personaId, stageName, ideaContent, chosen) =>
    dispatch(addIdea(ideaId, personaId, stageName, ideaContent, chosen)),
  // -- ADD IDEA END -- 

    // -- DELETE IDEA START --
    deleteIdeaDBOnly: (personaId, stageName, id) =>
      dispatch(deleteIdeaDBOnly(personaId, stageName, id)),
    deleteIdea: (stageName, ideaId) =>
      dispatch(deleteIdea(stageName, ideaId)),
    // -- DELETE IDEA END --

    // -- SELECT IDEA START --
    selectIdeaDBOnly: (journeyId, personaId, stageName, ideaId) =>
      dispatch(selectIdeaDBOnly(journeyId, personaId, stageName, ideaId)),
    selectIdea: (personaId, stageName, ideaId, chosen) =>
      dispatch(selectIdea(personaId, stageName, ideaId, chosen)),
    // -- SELECT IDEA END --

  // -- UPDATE IDEA START -- CERTIFIED
  updateIdeaDBOnly: (personaId, ideaId, stageName, ideaContent) =>
    dispatch(updateIdeaDBOnly(personaId, ideaId, stageName, ideaContent)),
  updateIdea: (personaId, ideaId, stageName, ideaContent) =>
    dispatch(updateIdea(personaId, ideaId, stageName, ideaContent)),
  // -- UPDATE IDEA END --

   // -- ADD PERSONA START --
   addPersona : (personaId, name, role, hero, pic_url) =>
   dispatch(addPersona(personaId, name, role, hero, pic_url)),

   addPersonaDBOnly : (journeyId, name, role, hero, picUrl) =>
   dispatch(addPersonaDBOnly(journeyId, name, role, hero, picUrl)),
  
   // -- ADD PERSONA START --

   // -- DELETE PERSONA START -
   deletePersona : (personaId) =>
   dispatch(deletePersona(personaId)),

   deletePersonaDBOnly : (personaId) =>
   dispatch(deletePersonaDBOnly(personaId)),

   // -- DELETE PERSONA START -

   // -- EDIT PERSONA START -
   editPersona : (id, name, role, hero, picUrl) =>
   dispatch(editPersona(id, name, role, hero, picUrl)),

   // -- EDIT PERSONA START -
});

export default connect(mapStateToProps, mapDispatchToProps)(Personas);
